document.addEventListener('DOMContentLoaded', function () {

  let selectedComboProducts = [];



  /*
  =========================================
  COMBO SELECT BUTTON
  =========================================
  */

  document.addEventListener('click', function (e) {

    if (e.target.classList.contains('combo-add-btn')) {

      e.preventDefault();

      const button = e.target;

      const variantId =
        button.getAttribute('data-variant-id');

      const card =
        button.closest('.combo-card');



      /*
      REMOVE
      */

      if (card.classList.contains('combo-selected')) {

        card.classList.remove('combo-selected');

        button.innerHTML = '+ Add';

        selectedComboProducts =
          selectedComboProducts.filter(
            item => item.id !== variantId
          );

      }



      /*
      ADD
      */

      else {

        card.classList.add('combo-selected');

        button.innerHTML = '✓ Selected';

        selectedComboProducts.push({
          id: variantId,
          quantity: 1
        });

      }

    }

  });




  /*
  =========================================
  EXISTING ADD TO CART BUTTON
  =========================================
  */

  const addToCartBtn =
  document.querySelector(
    'button[name="add"]'
  );

if (addToCartBtn) {

  addToCartBtn.addEventListener(
    'click',
    function (e) {

      if (selectedComboProducts.length < 1) {
        return;
      }

      e.preventDefault();

      addToCartBtn.disabled = true;

      addToCartBtn.innerHTML =
        'Redirecting...';



      /*
      MAIN PRODUCT
      */

      const mainVariant =
        document.querySelector(
          'select[name="id"]'
        ).value;



      /*
      BUILD CART URL
      */

      let cartUrl =
        '/cart/' + mainVariant + ':1';



      /*
      ADD COMBO PRODUCTS
      */

      selectedComboProducts.forEach(item => {

        cartUrl += ',' + item.id + ':1';

      });



      /*
      DIRECT CHECKOUT
      */

      cartUrl += '?checkout';



      window.location.href =
        cartUrl;

    }

  );

}


  /*
  =========================================
  CAROUSEL
  =========================================
  */

  document.querySelectorAll('.combo-group')
  .forEach(group => {

    const grid =
      group.querySelector('.combo-grid');

    const prev =
      group.querySelector('.combo-prev');

    const next =
      group.querySelector('.combo-next');



    if (prev) {

      prev.addEventListener(
        'click',
        () => {

          grid.scrollBy({
            left: -300,
            behavior: 'smooth'
          });

        }
      );

    }



    if (next) {

      next.addEventListener(
        'click',
        () => {

          grid.scrollBy({
            left: 300,
            behavior: 'smooth'
          });

        }
      );

    }

  });

});